var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3153 8.71346L20.5 7.52874L15.9713 3L11.2891 7.68216L12.4738 8.86688L15.136 6.20471L15.136 9.55078L15.1301 9.80005C15.1301 10.7074 14.7466 11.5775 14.0639 12.2191C13.3813 12.8607 12.4554 13.2211 11.4901 13.2211H3.5V14.8H11.4901C12.901 14.8 14.2542 14.2733 15.2519 13.3356C16.2496 12.3979 16.8101 11.1261 16.8101 9.80005L16.8065 9.55078V6.20471L19.3153 8.71346Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUp);
export default __webpack_public_path__ + "static/media/arrow-right-up.7052203536f625b9c769e6ec7e46c5ec.svg";
export { ForwardRef as ReactComponent };